import { restClient } from '../../client';
import { MentalHealthRole, ProviderDetail, State, User, UserContact, UserProfile } from '../../resources';

export type GetProviderSettingsResponse = {
  user: User;
  profile?: UserProfile;
  providerDetails?: ProviderDetail;
  contacts: UserContact[];
  states: State[];
  mentalHealthRoles: MentalHealthRole[];
};

export const getProviderSettings = (_params: null) => restClient.request<GetProviderSettingsResponse>('/api/v1/provider/settings', {
  method: 'GET'
});
